import { BoothMark } from "./booth-mark.tsx";
import { GoogleMark } from "./icons.tsx";
import type { SiteConfig } from "./oauth.ts";
import { signIn, signOut } from "./session.ts";
import type { SignInFailure } from "./sign-in-errors.ts";
import { Button, Callout, Card } from "./ui.tsx";

interface Props {
  /** Absent when config.json could not be read; there is nowhere to sign in to. */
  config: SiteConfig | null;
  /** A bold line and, when there is something useful to add, a line under it. */
  error: SignInFailure | null;
}

/** The only layout a signed-out person sees, failures included. */
export function SignInScreen({ config, error }: Props) {
  return (
    <div class="signin">
      <Card class="signin-card">
        <BoothMark size={56} />
        <h1 class="page-title centred">Booth Messages</h1>
        <p class="lede centred">Sign in to manage the booth's messages.</p>
        {error && (
          <Callout tone="bad" title={error.title}>
            {error.detail}
          </Callout>
        )}
        {config && !error && (
          <Button tone="primary" full onClick={() => void signIn(config)}>
            <GoogleMark />
            <span>Continue with Google</span>
          </Button>
        )}
        {config && error && (
          <Button full onClick={() => signOut(config)}>
            Start over
          </Button>
        )}
      </Card>
      <p class="meta centred">Only people on the booth's list can sign in.</p>
    </div>
  );
}
